/**
 * Registra el service worker en producción (requiere HTTPS, excepto localhost).
 * No afecta llamadas a /api: el SW las deja pasar sin caché.
 */
export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return;
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
    navigator.serviceWorker
      .register(swUrl, { scope: `${process.env.PUBLIC_URL || ""}/` })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[ICJEME PWA] No se pudo registrar el service worker:", err);
      });
  });
}
